import React from 'react';

import { dividerBase } from './SectionDivider.style';

/**
 * @param {{ marginTop?: number, marginBottom?: number }} props
 */
const SectionDivider = ({ marginTop = 0, marginBottom = 0 }) => (
    <div role="separator" style={{ ...dividerBase, marginTop, marginBottom }} />
);

export default SectionDivider;
